import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MingleService } from '@totvs/mingle';
import { BehaviorSubject, Observable } from 'rxjs';
import { NetworkService } from './network.service';
import { SetupSyncService } from './setup-sync.service';


@Injectable({
  providedIn: 'root'
})
export class LoginService {
  authOk = new BehaviorSubject<boolean>(false);
  hasTheTokenExpired = new BehaviorSubject<boolean>(false);

  constructor(
    private router: Router,
    private mingleService: MingleService,
    private networkService: NetworkService,
    private setupSyncService: SetupSyncService
  ) { }

  isLoggedIn(): boolean {
    if (
      localStorage.getItem('user') === '' ||
      localStorage.getItem('user') === null
    ) {
      return false;
    } else {
      this.authOk.next(true);
      return true;
    }
  }

  logoutAuth(): void {
    this.networkService.setConnectionToOffline(false);
    localStorage.removeItem('user');
    this.authOk.next(false);
    this.router.navigate(['login']);
    this.mingleService.auth.logout().subscribe(async () => {
      await this.setupSyncService.destroySync();
      localStorage.removeItem('user');
      this.authOk.next(false);
      this.router.navigate(['login']);
      this.setupSyncService.cleanCompanyAndBranch();
    });
  }

  getAuth(): Observable<boolean> {
    return this.authOk.asObservable();
  }

  setExpiredToken(status: boolean): void {
    this.hasTheTokenExpired.next(status);
  }

  getExpiredToken(): Observable<boolean> {
    return this.hasTheTokenExpired.asObservable();
  }

  refreshUserToken(): void {
    if(this.networkService.getConnectionStatus().status){
      this.mingleService.auth.refreshToken();
    }
  }

}
